import React from "react";
import QuicksightDashboard from "@src/components/atoms/manager/QuicksightDashboard";

const AnalysisTab = () => {
  return <QuicksightDashboard hideTitle={true} hideDivider={true} />;
};
export default AnalysisTab;
